import React from 'react';

const DateTimeDisplay = ({ value }) => {
  return (
    <span className={'countdown'}>
        {value}
    </span>
  );
};

export default DateTimeDisplay;
